import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { useParams } from "react-router";
import { WASTE_LINES_UNIFIED_QUERY } from "routes/Customer/Waste/ManifestLineItems/Preview/api";

import { useCurrentUser } from "./useCurrentUser";

export interface UseWasteLinesUnifiedParams {
  search?: string;
  page?: number;
  pageSize?: number;
  sort?: Array<{ field: string; sort: string }>;
}

interface UseWasteLinesUnifiedOptions {
  skip?: boolean;
}

export const useWasteLinesUnified = (
  params?: UseWasteLinesUnifiedParams,
  { skip }: UseWasteLinesUnifiedOptions = {}
) => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const { isStaff, loading: userLoading } = useCurrentUser();

  const { data, loading, error } = useQuery(WASTE_LINES_UNIFIED_QUERY, {
    variables: {
      search: params?.search,
      page: params?.page || 0,
      pageSize: params?.pageSize || 10,
      sort: params?.sort,
      includeOriginalVendorWasteLine: isStaff,
    },
    skip: !tenantId || skip || userLoading || userLoading,
  });

  return useMemo(() => {
    return {
      data,
      loading,
      error,
      items: data?.wasteLinesUnified?.items || [],
      count: data?.wasteLinesUnified?.count || 0,
    };
  }, [data, loading, error]);
};
